import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import config from 'config'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { convertUTCToTimezone, getTimeFormat1 } from 'srcReact/helpers/datetimeHelper'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import MixrSuggestionPopin from 'srcReact/components/popinsContent/MixrSuggestionPopin'
import { appConstantSettings } from 'srcReact/appConstantSettings'

const MixrSuggestions = ({ mixr, index }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [showSuggestionModal, setShowSuggestionModal] = useState(false)
  const {
    groupHome: { group }
  } = useSelector((state) => state)

  const date = convertUTCToTimezone(
    mixr.utc_start_at,
    mixr.location.timezone.UTCOffset,
    appConstantSettings.DATE_FORMAT5
  )
  const startTime = convertUTCToTimezone(mixr.utc_start_at, mixr.location.timezone.UTCOffset, getTimeFormat1())
  const endTime = convertUTCToTimezone(mixr.utc_end_at, mixr.location.timezone.UTCOffset, getTimeFormat1())

  const handleRejectClick = () => {
    dispatch(groupHomeActions.suggestedRejectMixrGroup(mixr.id))
    setShowSuggestionModal(false)
  }

  const handleAcceptClick = () => {
    dispatch(groupHomeActions.suggestedAcceptMixrGroup(mixr.id, mixr.attending_type))
    setShowSuggestionModal(false)
  }

  return (
    <div className={styles.mixrSuggestionsWrapper}>
      <div className={styles.mixr}>
        <div className={styles.info}>
          <div className={styles.datetime}>
            {date} - {startTime}-{endTime}
          </div>
          <div className={styles.name}>{mixr.name}</div>
          <div className={styles.moreInfo} onClick={() => setShowSuggestionModal(!showSuggestionModal)}>
            {t('global.moreInfo')} <Icon name='arrow-right' size='large24' />
          </div>
        </div>
        <div className={styles.action}>
          <div
            className={styles.closeIcon}
            onClick={() => dispatch(groupHomeActions.suggestedRejectMixrGroup(mixr.id))}>
            <Icon name='close' size='x-small' />
          </div>
          <div
            className={styles.checkedIcon}
            onClick={() => dispatch(groupHomeActions.suggestedAcceptMixrGroup(mixr.id, mixr.attending_type))}>
            <Icon name='checked' size='medium' />
          </div>
        </div>
      </div>
      <MixrSuggestionPopin
        title={mixr.name}
        picture={mixr.picture?.url}
        startDate={mixr.utc_start_at}
        endDate={mixr.utc_end_at}
        utcOffset={mixr.location.timezone.UTCOffset || '+00:00'}
        timezone={mixr.location.timezone.timeZoneAbbreviation}
        description={mixr.description}
        color={mixr.color ? mixr.color : appConstantSettings.DEFAULT_COLOR.name}
        isRecurrence={mixr.is_recurrent_mixr === 1 ? true : false}
        attendance={mixr.logged_user.mixr_attending}
        userAttendance={mixr.attending_type}
        isVisibility={group.privacy_setting !== 'public'}
        location={mixr.location.adresse}
        showSuggestionMixr={showSuggestionModal}
        closeSuggestionMixr={() => setShowSuggestionModal(false)}
        handleRejectClick={handleRejectClick}
        handleAcceptClick={handleAcceptClick}
      />
    </div>
  )
}

export default MixrSuggestions
